import { fillArr } from '@hglobal/fin-ui';

import { User } from '@kr/models';

export function getUserMock(i: number): User {
  return {
    id: i,
    firstName: `Ivan`,
    lastName: `Ivanov`,
  };
}

export function getUsersMock(count = 12): User[] {
  return fillArr(count, i => getUserMock(i));
}
